import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Color from "../../editors/color";
import { db } from "../../firebase";

export default function Design({ palette = [], appId }) {
  const handleSave = (index, value) => {
    const _palette = [...palette];
    _palette[index] = value;
    db.collection("apps")
      .doc(appId)
      .set({ palette: _palette }, { merge: true });
  };

  const handleAdd = () => {
    const _palette = [...palette];
    _palette.push("#f2f2f2");
    db.collection("apps")
      .doc(appId)
      .set({ palette: _palette }, { merge: true });
  };
  return (
    <div className={styles.paper}>
      <div>
        <div className={styles.subtitle}>App Color Palette</div>
        <div style={{ display: "flex", marginTop: 12 }}>
          {palette.map((v, index) => {
            return (
              <div key={v} className={styles.colorContainer}>
                <Color value={v} onChange={(v) => handleSave(index, v)} />
              </div>
            );
          })}
          <div className={styles.colorContainer}>
            <button onClick={handleAdd} className={styles.add}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
